import { cn } from '@rocco/utils/cn';

/**
 * Tailwind CSS classes for rich text for different HTML elements.
 */
const RICH_TEXT_CLASSES = {
    a: '[&_a:hover]:text-black [&_a]:underline',
    p: '[&_p]:mb-4',
    ul: '[&_ul]:mb-4 [&_ul]:pl-8 [&_ul]:list-disc',
    menu: '[&_menu]:mb-4 [&_menu]:pl-8 [&_menu]:list-disc',
    ol: '[&_ol]:mb-4 [&_ol]:pl-8 [&_ol]:list-decimal',
};

/**
 * Tailwind CSS classes for rich text.
 */
export const RICH_TEXT_CLASS = cn(
    RICH_TEXT_CLASSES.a,
    RICH_TEXT_CLASSES.p,
    RICH_TEXT_CLASSES.ul,
    RICH_TEXT_CLASSES.menu,
    RICH_TEXT_CLASSES.ol
);
